const React = require('react');
const PropTypes = require('prop-types');
const NotLoggedUserFundBox = require('./NotLoggedUserFundBox');
const LoggedOnPublicUserFundBox = require('./LoggedOnPublicUserFundBox');
const ProspectUserBox = require('./ProspectUserBox');

class PublicUserFundBox extends React.Component {
    constructor(props) {
        super(props);
    }

    buildBoxPublicbyUser(fund, user, isProspectUser, isLoggedUser, isAlternativeFund) {

        if(isLoggedUser) {
            return (<LoggedOnPublicUserFundBox
                fund={fund}
                user={user}
                isAlternativeFund={isAlternativeFund}
            />
            )
        }

        if(!isProspectUser) { // Customer
            return (<NotLoggedUserFundBox
                fund={fund}
                user={user}
                isAlternativeFund={isAlternativeFund}
            />
            )
        }

        return (<ProspectUserBox
            fund={fund}
            user={user}
            isAlternativeFund={isAlternativeFund}
        />
        )
    }

    render() {
        const {
            fund,
            user,
            isAlternativeFund
        } = this.props;

        const isProspectUser= user.get('isProspectUser',false);
        const isLoggedUser= user.get('isLoggedUser',false);



        return (
            <React.Fragment>
                {this.buildBoxPublicbyUser(fund, user, isProspectUser, isLoggedUser, isAlternativeFund)}
            </React.Fragment>
        );
    }
}


PublicUserFundBox.propTypes = {
    fund: PropTypes.object,
    user: PropTypes.object,
    isAlternativeFund: PropTypes.bool
};


module.exports = PublicUserFundBox
